import { Grid, Typography, styled } from '@mui/material'

export const Wrapper = styled(Grid)(({ theme }) => ({
  marginBottom: theme.spacing(5),

  [theme.breakpoints.down('md')]: {
    marginBottom: theme.spacing(2),
  },
}))

export const Title = styled(Typography)(({ theme }) => ({
  fontSize: '2.25rem',
  lineHeight: '2.625rem',

  [theme.breakpoints.down('md')]: {
    fontSize: '1.5rem',
    lineHeight: '1.75rem',
  },
}))

export const Subtitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[600],

  [theme.breakpoints.down('md')]: {
    fontSize: '1.25rem',
    lineHeight: '1.5rem',
    marginBottom: theme.spacing(1),
  },
}))
